export enum Importer {
  ScanWebsite = 'Scan Website',
  AddText = 'Add Text',
  SelectDoc = 'Select Doc',
  UploadFiles = 'Upload Files',
}
